import { EnvironmentConfig } from 'src/environments/env.model';

export const environment: EnvironmentConfig = {
    production: true,
    baseURL: 'https://core.nekta.cloud/api/',
    socketUrl: '//' + window.location.host,
    buildType: 'cloud',
    errorLogger: true,
    isKerberos: false,
    ldapSupport: false,
    useRandomPasswords: false,
    useDigitalSignature: false,
};
